/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconScriptPlus = createReactComponent("script-plus", "IconScriptPlus", [
  ["path", { d: "M17 19h4", key: "svg-0" }],
  [
    "path",
    {
      d: "M14 20h-8a3 3 0 0 1 0 -6h11a3 3 0 0 0 -3 3m7 -3v-8a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v8",
      key: "svg-1"
    }
  ],
  ["path", { d: "M19 17v4", key: "svg-2" }]
]);

export { IconScriptPlus as default };
//# sourceMappingURL=IconScriptPlus.js.map
